import { useState } from 'react';
import People from 'elem/SVGIcon/PowerBackup/People';
import Store from 'elem/SVGIcon/PowerBackup/Store';
import XStream from 'elem/SVGIcon/PowerBackup/XStream';
import XBoost from 'elem/SVGIcon/PowerBackup/XBoost';
import LFP from 'elem/SVGIcon/PowerBackup/LFP';
import BMS from 'elem/SVGIcon/PowerBackup/BMS';
import Chat from 'elem/SVGIcon/PowerBackup/Chat';
import APR from 'elem/SVGIcon/PowerBackup/APR';
import Warranty from 'elem/SVGIcon/PowerBackup/Warranty';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { useScrollAnimation, cn } from 'elem/compPage/battery-backup-for-home/scroll-animation-v2';

// 箭头图标
const ArrowIcon = ({ isOpen }: { isOpen: boolean }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}
    >
        <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default function Why() {
    const { t } = useLang('powerbackup');
    const { locale } = getLocal();
    const [activeIndex, setActiveIndex] = useState(0);

    const { ref, isVisible } = useScrollAnimation({
        threshold: 0.1,
    });

    const lists = [
        {
            title: t('secJ_list1_title'),
            desc: t('secJ_list1_desc'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1767683267287-j24ih8-compressed-Frame%202094654857.jpg',
            icons: [
                {
                    icon: <People />,
                    text: t('secJ_list1_icon1'),
                },
                {
                    icon: <Store />,
                    text: t('secJ_list1_icon2'),
                },
            ],
        },
        {
            title: t('secJ_list2_title'),
            desc: t('secJ_list2_desc'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1767683285197-46qzsz-compressed-Frame%202094654858.jpg',
            icons: [
                {
                    icon: <XStream className="original" />,
                    text: t('secJ_list2_icon1'),
                },
                {
                    icon: <XBoost className="original" />,
                    text: t('secJ_list2_icon2'),
                },
                {
                    icon: <LFP className="original" />,
                    text: t('secJ_list2_icon3'),
                },
                {
                    icon: <BMS className="original" />,
                    text: t('secJ_list2_icon4'),
                },
            ],
        },
        {
            title: t('secJ_list3_title'),
            desc: t('secJ_list3_desc'),
            image: 'https://websiteoss.ecoflow.com/figma-uploads/1769500636082-uykmem-compressed-Frame%202094655027.jpg',
            icons: [
                {
                    icon: <Chat />,
                    text: t('secJ_list3_icon1'),
                },
                {
                    icon: <APR className="original" />,
                    text: t('secJ_list3_icon2'),
                },
                {
                    icon: <Warranty />,
                    text: t('secJ_list3_icon3'),
                },
            ],
        },
    ];

    const handleToggle = (index: number) => {
        setActiveIndex(index === activeIndex ? -1 : index);
    };

    return (
        <div ref={ref} className={`${styles.Why} GtmModuleData-section`}>
            <div className="pb-layout">
                <div className={cn(isVisible, 'power-backup-title fade-up')}>{t('secJ_title')}</div>
                <div className={cn(isVisible, 'why-content fade-up')} style={{ '--animate-delay': '0.15s' } as React.CSSProperties}>
                    <div className="why-image">
                        <EcoImg pc={lists[activeIndex >= 0 ? activeIndex : 0]?.image} />
                    </div>
                    <div className="why-accordion">
                        {lists.map((item, index) => (
                            <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
                                <div className="accordion-header" onClick={() => handleToggle(index)}>
                                    <span className="accordion-title">{item.title}</span>
                                    <ArrowIcon isOpen={activeIndex === index} />
                                </div>
                                <div className="accordion-content">
                                    <div className="accordion-content-inner">
                                        {/* 移动端图片 */}
                                        <div className="accordion-image">
                                            <EcoImg pc={item.image} />
                                        </div>
                                        <p className="accordion-desc">{item.desc}</p>
                                        {item.icons && item.icons.length > 0 && (
                                            <div className="accordion-icons">
                                                {item.icons.map((iconItem, iconIndex) => (
                                                    <div key={iconIndex} className="icon-item">
                                                        <div className="icon-svg">{iconItem.icon}</div>
                                                        <span className="icon-text">{iconItem.text}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
